import React from 'react'
import MobileHeader from "../MobileComponents/MobileHeader";
import MobileBottomNav from "../MobileComponents/MobileBottomNav";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import ChatIcon from '@mui/icons-material/Chat';
import AvatarPic from "../../assets/images/avtarPic.png";
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { red } from '@mui/material/colors';
import { Box } from '@mui/material';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 10,
    p: 3,
  };
  
    
function MobileEmergency() {
  const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const initialValues = {
      message: "",
    };
  
    const validationSchema = Yup.object({
      message: Yup.string().required("Required"),
    });
  
    const onSubmit = (values) => console.log("Form Data", values);
  return (
    <div className='mainwrapperView'>
    <MobileHeader/>
      <div className="wraperMobile">
        <p className='EmergencyMainTxt'>Emergency Screen</p>
        <div className='famDetailsListInrMob'>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro">
            <div className="ImageViewRound">
              <img src={AvatarPic} />
            </div>
            <div className="detailsDiMob">
              <h1>Demo text</h1>
              <p>Test Building/wing A/F-01</p>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div className="listDeleEdiMob" onClick={handleOpen}>
            <ChatIcon style={{ color: "#21bd" }} />
          </div>
        </div>
        </div>
        <div className='famDetailsListInrMob'>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro">
          <div className="ImageViewRound">
              <img src={AvatarPic} />
            </div>
            <div className="detailsDiMob">
              <h1>Demo text</h1>
              <p>Test Building/wing A/F-01</p>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div className="listDeleEdiMob" onClick={handleOpen}>
            <ChatIcon style={{ color: "#21bd" }} />
          </div>
        </div>
        </div>
        <div className='famDetailsListInrMob'>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro">
            <div className="ImageViewRound">
              <img src={AvatarPic} />
            </div>
            <div className="detailsDiMob">
              <h1>Demo text</h1>
              <p>Test Building/wing A/F-01</p>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div className="listDeleEdiMob" onClick={handleOpen}>
            <ChatIcon style={{ color: "#21bd" }} />
          </div>
        </div>
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className='modalTitleView'>
            <p className='modalTitleTxt'>Send Message</p>
            <CloseIcon sx={{ color: red[600], fontSize: 25 }} onClick={handleClose} />
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
          {(formik) => (
          <Form>
          <div className='FormView'>
            <div className='lebalInputView'>
            {/* <p className='inputLebal'>Message</p>
            <textarea type='text' placeholder='Enter message here' className='textAreaInput' aria-multiline/> */}
            <FormikControl
              control="textarea"
              type="text"
              label="Message"
              placeholder="Enter message here"
              labelclassName="inputLebal"
              name="message"
              className="textAreaInput"
            />
            </div>
            <button className='submitButton' type='submit'>Submit</button>
          </div>
          </Form>
            )}
          </Formik>
        </Box>
      </Modal>
    <MobileBottomNav/>
    </div>
  )
}

export default MobileEmergency